package br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model

data class DashboardGameUI(
    val gameId: Long,
    val name: String,
    val imageUrl: String?,
    val count: Int
)
